import Vue from 'vue'
import AgGridVue from '@/components/ag-grid/AgGridVue'

const components = { AgGridVue }

Object.entries(components).forEach(([name, component]) => {
  Vue.component(name, component)
})
